import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/** Keep the secondary shortcut clear of purchase controls, without moving them. */
class RicordoTravelsLink extends Component {
  #controller;
  #observer;
  #frame = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    document.addEventListener('scroll', this.#schedule, { passive: true, capture: true, signal });
    document.addEventListener('focusin', this.#schedule, { signal });
    document.addEventListener('focusout', this.#schedule, { signal });
    document.addEventListener(ThemeEvents.FilterUpdate, this.#schedule, { signal });
    window.addEventListener('resize', this.#schedule, { passive: true, signal });
    window.addEventListener('load', this.#schedule, { once: true, signal });
    this.#observer = new ResizeObserver(this.#schedule);
    const main = document.querySelector('main');
    if (main) this.#observer.observe(main);
    this.#observer.observe(this);
    this.#schedule();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#observer?.disconnect();
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
  }

  #schedule = () => {
    if (this.#frame) return;
    this.#frame = requestAnimationFrame(() => {
      this.#frame = 0;
      this.#update();
    });
  };

  #update() {
    // The Shopify preview bar is editor chrome, not part of the production site.
    const preview = document.querySelector('#PBarNextFrame, #preview-bar-iframe')?.getBoundingClientRect();
    // The current bar uses a transparent full-viewport iframe around a 64px bar.
    const offset = preview?.height ? (preview.top > innerHeight / 2 ? Math.ceil(innerHeight - preview.top) : 64) : 0;
    this.style.setProperty('--rc-travels-preview-offset', `${offset}px`);

    // Never hide a shortcut the keyboard user is currently interacting with.
    if (this.contains(document.activeElement)) {
      this.removeAttribute('data-occluded');
      return;
    }
    const pill = this.getBoundingClientRect();
    const actions = document.querySelectorAll(
      '.rc-slide__button, .rc-shop-card__control, .facets-toggle__button, button[name="add"], .cart__checkout-button, ' +
        '.shopify-payment-button, shopify-accelerated-checkout, .rc-discovery-carousel button, .rc-discovery-carousel a'
    );
    const overlaps = Array.from(actions).some((action) => {
      const rect = action.getBoundingClientRect();
      if (!rect.width || !rect.height || getComputedStyle(action).visibility === 'hidden') return false;
      return rect.left < pill.right + 8 && rect.right > pill.left - 8 && rect.top < pill.bottom + 8 && rect.bottom > pill.top - 8;
    });
    this.toggleAttribute('data-occluded', overlaps);
  }
}

if (!customElements.get('ricordo-travels-link')) {
  customElements.define('ricordo-travels-link', RicordoTravelsLink);
}
